export const modalHeaderStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const badgeStyle = {
  margin: '2px',
};
